"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAssessmentRequest = void 0;
var GetAssessmentRequest = /** @class */ (function () {
    function GetAssessmentRequest() {
    }
    return GetAssessmentRequest;
}());
exports.GetAssessmentRequest = GetAssessmentRequest;
;
//# sourceMappingURL=getAssessment.request.js.map